// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"484b1fd7","509":"d61b7f91","798":"71e593b3"}[chunkId] + ".chunk.js";
};